import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import './Download.css';

const Download = () => {
    return (<div class="home-content">
        <ul>
            <li> <a href="../../../Assets/Document/scanned_bible.pdf" download><PictureAsPdfIcon  />Scanned PDF </a>   </li>
            <li> <a href="../../../Assets/Document/bible.pdf" download><PictureAsPdfIcon  /> PDF </a>   </li>
            <li> <a href="../../../Assets/Document/bible.docx" download> Documento de Word </a>  </li>
            <li> <a href="www.averdadeabiblia.com" > averdadeabiblia.com </a>  </li>
            <li> <a href="www.laveritelabible.com" > laveritelabible.comd </a>  </li>
        </ul>
        <div class="background">

        </div>
        
    </ div>)

}

export default Download; 
